import { useMemo } from 'react';

import {
	useCreationFocusedNavLand,
	loading,
	d0,
	d1,
} from '@confluence/experiment-cfind-4473-creation-focused-nav/entry-points/useCreationFocusedNavLand.ts';
import type { MenuId } from '../PlatformNavigation/PlatformNavigationTypes.ts';

export type PlatformCustomization = {
	menuId: MenuId;
	visible: boolean;
};

const STANDARD_ITEMS_HIDDEN: PlatformCustomization[] = [
	{ menuId: 'recent', visible: false },
	{ menuId: 'starred', visible: false },
	{ menuId: 'companyHubShortcut', visible: false },
	{ menuId: 'teamsShortcut', visible: false },
];

export const usePlatformCustomizationsWithSimplifyNav = (
	platformCustomizations: Array<PlatformCustomization>,
): {
	platformCustomizationsWithSimplifyNav: PlatformCustomization[];
} => {
	const { navCustomization } = useCreationFocusedNavLand(true);
	const platformCustomizationsWithSimplifyNav = useMemo(() => {
		let customizedForExperiment: PlatformCustomization[] = [];
		if (navCustomization === loading) {
			customizedForExperiment = [...STANDARD_ITEMS_HIDDEN, { menuId: 'templates', visible: false }];
		} else if (navCustomization === d0) {
			customizedForExperiment = [...STANDARD_ITEMS_HIDDEN, { menuId: 'templates', visible: true }];
		} else if (navCustomization === d1) {
			customizedForExperiment = [{ menuId: 'templates', visible: true }];
		}

		const customizedMenuIds = new Set(platformCustomizations.map((item) => item.menuId));
		const itemsToCustomize = customizedForExperiment.filter(
			(item) => !customizedMenuIds.has(item.menuId),
		);

		return [...platformCustomizations, ...itemsToCustomize];
	}, [platformCustomizations, navCustomization]);
	return { platformCustomizationsWithSimplifyNav };
};
